import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { AuthenticatorComponent } from './components/authenticator/authenticator.component';
import { ConfirmSignInComponent } from './components/confirm-sign-in/confirm-sign-in-component';
import { ConfirmSignUpComponent } from './components/confirm-sign-up/confirm-sign-up.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { RequireNewPasswordComponent } from './components/require-new-password/require-new-password.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { AmplifyService, AmplifyAngularModule } from 'aws-amplify-angular';
import { AuthRoutingModule } from './auth-rounting.module';
import { AuthConfig } from './auth-config';
import { AUTH_CONFIG_TOKEN } from './auth.service';
import { SharedWebModule } from 'src/app/shared/shared-web.module';

@NgModule({
  declarations: [
    SignInComponent,
    SignUpComponent,
    RequireNewPasswordComponent,
    ForgotPasswordComponent,
    ConfirmSignUpComponent,
    ConfirmSignInComponent,
    AuthenticatorComponent
  ],
  imports: [
    AuthRoutingModule,  
    AmplifyAngularModule, 
    SharedWebModule
  ],
  providers: [
    AmplifyService
  ],
  exports: [
    AuthenticatorComponent
  ],
  entryComponents :[
    AuthenticatorComponent
  ]
})
export class AuthModule {

  static forRoot(authConfig: AuthConfig): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [
        AmplifyService,
        { provide: AUTH_CONFIG_TOKEN, useValue: authConfig }
      ]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: AuthModule) {
    if (parentModule) {
      throw new Error('AuthModule is already loaded. Import it in the AppModule only');
    }
  }
}
